// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".searchTracks_root__BCcib {\n  padding: 20px;\n  margin-left: 10px;\n  margin-top: 10px;\n  box-sizing: border-box;\n  width: 100%;\n  background: #fff;\n  border-radius: 15px;\n  box-shadow: 2px 1px 11px 3px rgba(181, 181, 181, 0.4); }\n", ""]);
// Exports
exports.locals = {
	"root": "searchTracks_root__BCcib"
};
module.exports = exports;
